import {formData, globals as gl} from '../globals'
import { Modal } from '../modalCls'


export const formSubmit = () => {

  //generateModal('Musíte zvolit zda-li souhlasíte či ne.').appendTo($form);  
  if (!$('#phone')[0].value) { // error captcha robot vyplnil skryte pole
    const approved = $('input[name=approval-radio-group]:checked', '#approval-form').val() == 'true';
    if ($('input[name=approval-radio-group]:checked', '#approval-form').val() !== 'true' && $('input[name=approval-radio-group]:checked', '#approval-form').val() !== 'false') {
      let UncheckedModal = new Modal("Zvolte prosím jednu z možností.");
      UncheckedModal.show();
    } else {
      formData.sources[0].checked = approved;
      console.log(approved);
      console.log(formData);
      
      if (1) { // odeslat????
        let parsed = JSON.stringify(formData);
        $.ajax({
          type: "POST",
          cache: false,
          url: gl.updatePath,
          data: parsed,
          contentType: 'application/json',
          success: function (response) {
            let SuccessModal = new Modal("Děkujeme za vyplnění formuláře.");
            SuccessModal.show();
            //window.location.replace('/podekovani.html');
          },
          error: (function (e) {
            console.log('error', e);
            alert('Došlo k chybě při komnunikaci se serverem\n');
          })
        });
      }
    }
  } else {
    console.log('cpt error');
  }
};



// WEBPACK FOOTER //
// ./app/actions/submit.js